import * as React from 'react';
import { compose, setDisplayName } from 'recompose';
import { translate } from 'react-i18next';
import { TranslateProps } from 'util/i18n';
import { Fade } from 'ui/transitions';
import { Loading } from 'ui/shared/Loading';
import { Button } from 'ui/shared/Button';

type OwnProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
    id: string;
    type?: string;
    spinning: boolean;
    disabled?: boolean;
    textKey: string;
    titleKey?: string;
};

const styles: { [name: string]: React.CSSProperties } = {
    inline: {
        display: 'inline',
    },
    halfOpacity: {
        opacity: .5,
    },
};

const RawButtonWithSpinner = ({ id, type = 'button', spinning, disabled = false, textKey, t, ...otherProps }: OwnProps & TranslateProps) =>
    <div style={ styles.inline }>
        <Fade
            visible={ spinning }
            duration={ 200 }
            style={ styles.inline }
        >
            <span
                title={ t('1827') }
                style={ styles.halfOpacity }
            >
                <Loading
                    size="tiny"
                    centered={ false }
                />
            </span>
        </Fade>
        <Button
            id={ id }
            type={ type }
            disabled={ spinning || disabled }
            textKey={ textKey }
            { ...otherProps }
        />
    </div>
;

export const ButtonWithSpinner = compose<OwnProps & TranslateProps, OwnProps>(
    setDisplayName('ButtonWithSpinner'),
    translate(),
)(RawButtonWithSpinner);



// WEBPACK FOOTER //
// ./src/ui/shared/ButtonWithSpinner.tsx